/**
 * The link that opens the article composer pre-seeded, and the read of that link
 * back into a seed.
 *
 * Both ends live here because they sit in different features: the Brand details
 * tab builds the link, the composer reads it. One module owning the parameter
 * names is what stops a rename leaving one end behind - the failure would be an
 * unseeded composer, which looks like an ordinary blank form rather than a bug.
 *
 * It deliberately knows nothing about the composer's form shape. Turning a seed
 * into a form is `seededArticleForm`, next to the template it applies.
 */

export const NEW_ARTICLE_PATH = '/articles/new'

/** Brand axis value to pre-select. */
const BRAND_PARAM = 'brand'
/** Which template to fill the body from. */
const TEMPLATE_PARAM = 'template'
/** The only template on offer. */
const BRAND_TEMPLATE = 'brand'

export interface ComposerSeed {
	/** Brand axis value to tag the article with, or `null` for none. */
	brandCode: string | null
	/** Whether to fill the body from the brand template. */
	brandTemplate: boolean
}

/** The composer link for a brand's details article: brand tagged, template applied. */
export function brandArticleComposerLink(brandCode: string): string {
	const query = new URLSearchParams({ [BRAND_PARAM]: brandCode, [TEMPLATE_PARAM]: BRAND_TEMPLATE })
	return `${NEW_ARTICLE_PATH}?${query.toString()}`
}

/**
 * Read a composer link's seed. An absent or unrecognized parameter seeds nothing,
 * so a hand-edited URL opens an ordinary blank composer rather than failing.
 */
export function readComposerSeed(search: URLSearchParams): ComposerSeed {
	return {
		brandCode: search.get(BRAND_PARAM) || null,
		brandTemplate: search.get(TEMPLATE_PARAM) === BRAND_TEMPLATE,
	}
}
